/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Standards_LabelInputs */



/**
* | output |
* | --- |
* | "Standards" |
*
* @param {New_Project_Standards_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_standards_label = /** @type {((inputs?: New_Project_Standards_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Standards_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("normes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "it") return /** @type {LocalizedString} */ ("Standard")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стандарты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estándares")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标准")
	if (locale === "ja") return /** @type {LocalizedString} */ ("基準")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मानकों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Padrões")
	return /** @type {LocalizedString} */ ("Standards")
});